'use strict';

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.filter");

function intersection(arr1, arr2) {
  return arr1.filter(function (value, index) {
    return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index
    /* skips duplicates */
    ;
  });
}

module.exports = intersection;